import React, { useState } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";

function Studentcorrection() {
    const [showTable, setShowTable] = useState(false);
    const [selectBy, setSelectBy] = useState("");
    const navigate = useNavigate();


    const handleSearchClick = () => {
        setShowTable(true);
        // alert("hii")
    };

    const handleSelectChange = (e) => {
        setSelectBy(e.target.value);
    };
    return (
        <>
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <section className="content-header">
                                        <h1><i className="fa fa-university" />&nbsp;Student Corection</h1>
                                        <ol className="breadcrumb">
                                            <li>
                                                <a onClick={() => navigate("/admin-dashboard")} style={{ cursor: "pointer" }}>
                                                    <i className="fa fa-tachometer" style={{ marginRight: "5px" }}></i> Home
                                                </a>
                                            </li>
                                            <li className="active">DEO list</li>
                                        </ol>
                                        <h3 />
                                    </section>
                                </div>
                            </div>
                            <div className="row">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>Select By</label>
                                                    <select
                                                        className="form-select form-select-xs"
                                                        value={selectBy}
                                                        onChange={handleSelectChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Student-ID">Student ID</option>
                                                        <option value="School-Name">School Name &amp; Class</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {selectBy === "Student-ID" && (
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Student ID</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-xs number"
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {selectBy === "School-Name" && (
                                                <>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>School Name</label>
                                                            <select className="form-select form-select-xs select2">
                                                                <option>Select</option>
                                                                <option>School 1</option>
                                                                <option>School 2</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label>Class</label>
                                                            <select className="form-select form-select-xs">
                                                                <option>Select</option>
                                                                <option>Class IX</option>
                                                                <option>Class X</option>
                                                                <option>Class XI</option>
                                                                <option>Class XII</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label><br />
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={handleSearchClick}
                                                    >
                                                        Search
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {showTable && (
                                            <>
                                                <hr />
                                                <div className="table-responsive" id="table-container" >
                                                    <table id="studentTable" className="table table-bordered table-striped table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: '#f2f2f2' }} colSpan={13}>Student Details</th>
                                                                <th style={{ backgroundColor: '#f2f2f2' }} colSpan={8}>Communication Details</th>
                                                                <th style={{ backgroundColor: '#f2f2f2' }} colSpan={11}>Educational Details</th>
                                                                <th style={{ backgroundColor: '#f2f2f2' }}>Action</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Sl No.</th>
                                                                <th>Name of Candidate</th>
                                                                <th>School's Name</th>
                                                                <th>Class</th>
                                                                <th>Gender</th>
                                                                <th>Date of Birth</th>
                                                                <th>Father’s Name</th>
                                                                <th>Mother’s Name</th>
                                                                <th>Religion</th>
                                                                <th>Nationality</th>
                                                                <th>Aadhaar Number</th>
                                                                <th>Divyang</th>
                                                                <th>Caste</th>
                                                                <th>Area</th>
                                                                <th>State</th>
                                                                <th>District</th>
                                                                <th>Block</th>
                                                                <th>Address</th>
                                                                <th>Pin</th>
                                                                <th>Student Contact Number</th>
                                                                <th>Email ID</th>
                                                                <th>Category</th>
                                                                <th>Medium of Examination</th>
                                                                <th>Language I Subject</th>
                                                                <th>Language II Subject</th>
                                                                <th>Compulsory I Subject</th>
                                                                <th>Compulsory II Subject</th>
                                                                <th>Compulsory III Subject</th>
                                                                <th>Additional Subject</th>
                                                                <th>Registration Session</th>
                                                                <th>Registration Number</th>
                                                                <th>Last Exam Details</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td>Test</td>
                                                                <td>Kenda High School</td>
                                                                <td>Class IX</td>
                                                                <td>Male</td>
                                                                <td>12-12-2003</td>
                                                                <td>Test</td>
                                                                <td>Test</td>
                                                                <td>Hinduism</td>
                                                                <td>Indian</td>
                                                                <td>111122223333</td>
                                                                <td>None</td>
                                                                <td>SC</td>
                                                                <td>Rural</td>
                                                                <td>1111111111</td>
                                                                <td>abcd@gmail.com</td>
                                                                <td>48484</td>
                                                                <td>Hindi</td>
                                                                <td>Engish</td>
                                                                <td>Mathematics</td>
                                                                <td>Science</td>
                                                                <td>Social Science</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>None</td>
                                                                <td>
                                                                    <div className="btn-group">
                                                                        <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
                                                                            Action
                                                                        </button>
                                                                        <div className="dropdown-menu">
                                                                            <a className="dropdown-item" href="class-10-pdf.html">
                                                                                <i className="fa fa-eye" /> &nbsp;View
                                                                            </a>
                                                                            <a className="dropdown-item" href="#" id="editButton">
                                                                                <i className="fa fa-edit" /> &nbsp;Edit
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Studentcorrection